import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { ArticleTrustLabel } from "~/components/article/article-trust-label";
import { StyledTrustLogo } from "~/components/article/article-trust-label/styles";
import { BaseLink } from "~/components/common/base-link";
import { ContentSchemaRender } from "~/components/schema-render/content";

type Props = {
  $isToggle: boolean;
};

export const LatestCorrectionDateContainer = styled.div<Props>`
  cursor: pointer;
  &:after {
    position: absolute;
    content: "";

    border-inline-end: 5px solid transparent;
    border-block-end: 5px solid #4585ff;
    border-inline-start: 5px solid transparent;

    margin-block-start: 8px;
    margin-inline-start: 7px;

    transform: rotate(180deg);
    ${props => {
      if (!props.$isToggle) return;
      return css`
        transform: rotate(0deg);
      `;
    }}
  }
`;

export const LatestCorrectionDate = styled.u`
  color: #4585ff;

  cursor: pointer;
`;

export const List = styled.ul<Props>`
  display: ${props => (props.$isToggle ? "block" : "none")};

  padding-block: 16px;
  padding-inline: 30px;

  background-color: #f2f6ff;
`;

export const Item = styled.li`
  position: relative;

  &:before {
    position: absolute;
    inset-inline-start: -12px;
    content: "•";

    padding-inline-end: 5px;
  }
`;
export const CorrectionDate = styled.b``;
export const TrustContainer = styled.div`
  display: flex;
  justify-content: end;

  color: #666666;
`;
export const StyledArticleTrustLabel = styled(ArticleTrustLabel)`
  align-items: center;

  font-size: 12px;
  line-height: 14px;

  ${StyledTrustLogo} {
    block-size: unset;
    margin-inline-end: 6px;
    path {
      fill: #666666;
    }
  }
`;
export const StyledContentSchemaRender = styled(ContentSchemaRender)`
  display: inline;

  margin-inline-start: 5px;
`;

export const StyledBaseLink = styled(BaseLink)`
  margin-inline-start: 8px;

  color: #333333;
  text-decoration: underline;

  cursor: pointer;
`;

export type ContainerProps = {
  $variant: "dark" | "light";
};

export const Container = styled.div<ContainerProps>`
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;

  ${props =>
    props.$variant === "dark" &&
    css`
      ${StyledArticleTrustLabel} {
        color: #cccccc;
      }

      ${StyledBaseLink} {
        color: #ffffff;
      }

      ${List} {
        color: #ffffff;

        background-color: #000000;
      }

      ${CorrectionDate} {
        color: #ffffff;
      }
    `}

  ${List} {
    margin-block: 8px 0;

    list-style: none;
  }

  ${Item} {
    margin-block-end: 12px;
  }
`;
